import React from "react";
import { Input } from "@inspinia-react/form/input";
import { connect } from "react-redux";
import { api, get } from "@config";
import { bindActionCreators } from "redux";

import { setPersonDoc } from "@parts/person/actions";
import { setLoading } from "@inspinia-react/actions";
import { notification } from "antd";

import { validateCPF } from "../document-component/validate-cpf";
import { validateCNPJ } from "../document-component/validate-cnpj";
import { mapTest } from "../../pages/products/map.test";
import ImportCNPJ from "../../../_components/ImportCNPJ";
import {
  setBasePersonName,
  setBasePersonEmail,
  setBasePersonPhoneNumber,
} from "../base-person/actions";
import { setCNAE, setFancyName } from "../company-data/actions";
import {
  setPostalCode,
  setStreetNumber,
  setComplement,
  setStateLocation,
  setCityLocation,
  setStreet,
  setDistrict,
} from "../address-component/actions";

class DocumentComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mask: [
        "999.999.999-99",
        "99.999.999/9999-99",
        "99.999.999/9999-99",
        "999.999.999-99",
      ],
      documentType: ["CPF", "CNPJ", "CNPJ", "CPF"],
    };
    this._onChange = this._onChange.bind(this);
  }

  validate(e) {
    const docComp = document.getElementById("document");
    docComp.setAttribute("validate-error", false);

    const isCompany = ![0, 3].includes(this.props.type);
    if (isCompany && e.length == 14) {
      if (!validateCNPJ(e)) {
        notification.open({
          message: "CNPJ Invalido",
          type: "error",
          key: "003",
        });
      } else {
        this.searchDoc(e);
      }
    } else if (!isCompany && e.length == 11) {
      if (!validateCPF(e)) {
        notification.open({
          message: "CPF Invalido",
          type: "error",
          key: "004",
        });
      } else {
        this.searchDoc(e);
      }
    }
  }

  _onChange(e) {
    this.props.setPersonDoc(e);
    if (!this.props.noValidation) {
      this.validate(e);
    }
  }

  searchDoc(doc) {
    this.props.setLoading(true);
    const url = `${api.searchCmpanyByCnpj}=${doc}`;
    const payload = (data) => {
      this.props.setLoading(false);

      const docComp = document.getElementById("document");
      if (data.status) {
        docComp.setAttribute("validate-error", true);

        const isCompany = ![0, 3].includes(this.props.type);
        const docLabel = isCompany ? "CNPJ" : "CPF";

        notification.open({
          message: `${docLabel} ja cadastrado`,
          type: "error",
          key: "001",
        });
      } else {
        docComp.setAttribute("validate-error", false);
      }
    };
    get(url, payload, (err) => this.props.setLoading(false));
  }

  render() {
    const { type, doc } = this.props;
    const handleSuccess = (data) => {
      this.props.setBasePersonName(data.name);
      this.props.setBasePersonEmail(data.email);
      this.props.setBasePersonPhoneNumber(data.phone_number);
      this.props.setFancyName(data.company.fancy_name);
      this.props.setPostalCode(data.address.postal_code);
      this.props.setStreetNumber(data.address.street_number);
      this.props.setComplement(data.address.complement);
      this.props.setStateLocation({
        id: data.address.state_location,
        value: data.address.state_location,
        label: data.address.state_location_uf,
      });
      this.props.setCityLocation({
        id: data.address.city_location,
        value: data.address.city_location,
        label: data.address.city_location_name,
      });
      this.props.setStreet(data.address.street);
      this.props.setDistrict(data.address.district);
    };
    return (
      <div>
        Documento
        <Input
          onChange={this._onChange}
          value={doc}
          id={mapTest.createClient.clientDocumentInput}
          placeholder={`Insira aqui o ${this.state.documentType[type]}`}
          mask={this.state.mask[type]}
        />
        {type === 1 ? (
          <ImportCNPJ onSuccess={handleSuccess} cnpj={doc} />
        ) : (
          <span />
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  type: state.personType,
  doc: state.personDoc,
  loading: state.loading,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPersonDoc,
      setLoading,
      setBasePersonName,
      setBasePersonEmail,
      setBasePersonPhoneNumber,
      setCNAE,
      setFancyName,
      setPostalCode,
      setStreetNumber,
      setComplement,
      setStateLocation,
      setCityLocation,
      setStreet,
      setDistrict,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DocumentComponent);



// WEBPACK FOOTER //
// ./src/components/parts/person/document.jsx